<div class="page hug-pre-engagement">
  <main class="mContent overflow-auto overflow-x-hidden">
    <section class="pre-engage-header">
      <h2 class="pre-engage-header__title">
        {{lessonDetails?.lesson_plan_name}}
      </h2>
      <div class="pre-engage-header__buttons">
        <button mat-raised-button color="white" class="hug-main-button" (click)="easyRead()">
          Easy Read
        </button>
        <button mat-raised-button color="white" class="hug-main-button" (click)="readWith()">
          Read With
        </button>
        <button mat-raised-button color="white" class="hug-main-button" (click)="handleUfliSTratergyModal(true)">
          UFLI Strategies
        </button>
      </div>
    </section>

    <nav class="hug-psc-navigation">
      <div class="hug-psc-navigation__container">
        <h2 class="hug-h2 text-center text-primary" style="font-size: 30px;">
          Post Engagement Review
        </h2>
      </div>
    </nav>

    <form [formGroup]="updateStudentProgressGroup">
      <div class="hug-tutor-bg mat-typography">
        <div class="hug-container pt-8">
          <div formArrayName="passages" class="text-center">
            <div *ngFor="let passage of sessionEngageDetails; let i = index">
              <h1 class="hug-h1 text-center text-primary mb-8" style="font-size: 56px;">
                Passage {{i + 1}} Reading: {{passage?.passage_name}}
                <span class="text-danger">*</span>
              </h1>
              <div class="row">
                <div class="col-md-4">
                  <div class="hug-card hug-card--count hug-custom-card-container">
                    <header class="hug-card__header">
                      <h2 class="hug-h3">
                        <span>Total Word</span>Count<br /><br />
                      </h2>
                      <span class="hug-card__count">
                        {{passage?.word_count || "N/A"}}
                      </span>
                    </header>
                    <div class="hug-card__body">
                      <img class="hug-card__graphics" src="assets/images/tutor/tutor-card-total1.svg"
                        alt="Total Word Count graphics" />
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="hug-card hug-card--first hug-custom-card-container">
                    <header class="hug-card__header">
                      <h2 class="hug-h3">
                        <span class="hug-h3">Words Missed</span>First Attempt<span
                          style="color: black; font-size: small; padding-top: 2mm"># of words highlighted <span
                            class="d-inline-block" style="font-size: medium; font-weight: 600 !important;">
                            yellow
                          </span></span>
                      </h2>
                    </header>
                    <div class="hug-card__body">
                      <img class="hug-card__graphics" src="assets/images/tutor/tutor-card-first1.svg"
                        alt="Words Missed First Attempt graphics" />
                    </div>

                    <app-increment-input class="hug-increment" 
                      [formGrp]="getPassageFormGroup(i)"
                      [inputName]="'words_missed_first'" 
                      matInput
                      type="number" 
                      [isReadOnly]="true"
                      [value]="getFormControlValue(i, 'words_missed_first')">
                    </app-increment-input>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="hug-card hug-card--second hug-custom-card-container">
                    <header class="hug-card__header d-block">
                      <h2 class="hug-h3">
                        <span>Words Missed <strong class="d-inline-block"
                            style="font-size: larger;">Twice</strong></span>
                        Second Attempt
                        <span style="color: black; font-size: small; padding-top: 2mm">
                          # of words highlighted
                          <span class="d-inline-block" style="font-size: medium; font-weight: 600 !important;">
                            yellow & blue
                          </span>
                        </span>
                      </h2>
                    </header>
                    <div class="hug-card__body">
                      <img class="hug-card__graphics" src="assets/images/tutor/tutor-card-second1.svg"
                        alt="Words Missed Second Attempt graphics" />
                    </div>
                    <app-increment-input class="hug-increment" 
                      [formGrp]="getPassageFormGroup(i)"
                      [inputName]="'words_missed_second'" 
                      matInput
                      type="number" 
                      [isReadOnly]="true"
                      [value]="getFormControlValue(i, 'words_missed_second')">
                    </app-increment-input>
                  </div>
                </div>
              </div>

              <div class="hug-tutor-learned hug-custom-margin-bottom mb-8">
                <h2 class="hug-h2 text-center text-primary">
                  Total Words Learned
                </h2>
                <div class="hug-tutor-learned__count">
                  <app-increment-input class="hug-increment text-primary" 
                    [formGrp]="getPassageFormGroup(i)"
                    [inputName]="'total_words_learned'" 
                    matInput 
                    type="number"
                    [isReadOnly]="true"
                    [value]="getFormControlValue(i, 'total_words_learned')">
                  </app-increment-input>

                  <mat-hint class="mat-error text-danger" *ngIf="wordMissedFirst[i] < wordMissedSecond[i]">
                    Children, we know you learned extra words!
                    Tutors, please contact your H.U.G. online specialist
                  </mat-hint>
                </div>
              </div>
            </div>

            <button mat-raised-button color="primary" class="hug-main-button miro-btn mb-4" (click)="onBackToHugClassroom()">
              Back to H.U.G. Classroom
            </button>
          </div>
        </div>
        <div class="hug-tutor-separator">
          <img src="assets/images/tutor/tutor-separator.svg" alt="Separator graphics" role="presentation" />
        </div>
      </div>
    </form>

  </main>
  <div class="modal" [ngClass]="{'active': reviewPercentageModal}" id="reviewPercentageModal">
    <div class="modal__box box-position">
      <div class="modal__header hidden">
        <button class="close" aria-label="Close" (click)="reviewModalClose()">×</button>
      </div>
      <div class="modal__body">
        <div class="hug-er-congrats">
          <img src="../../../../../assets/images/review-star.png" alt="star icon">
          <h3>Congratulations</h3>
          <p>Your changes have been successfully saved!</p>
        </div>

        <div class="hug-er-progress-wrap" *ngFor="let passage of sessionEngageDetails; let i = index">
          <h3 class="hug-er-progress-title">Passage {{i + 1}}: {{passage?.passage_name}}</h3>
          <div class="hug-er-progress">
            <p class="hug-er-progress__text">First Attempt</p>
            <div class="hug-er-progress__bar">
              <span class="hug-er-progress__bar__inner hug-er-progress__bar__inner--orange" [style.width.%]="getAcumenData1(passage)"></span>
            </div>
            <p class="hug-er-progress__percentage">{{getAcumenData1(passage)}}%</p>
          </div>
          <div class="hug-er-progress">
            <p class="hug-er-progress__text">Second Attempt</p>
            <div class="hug-er-progress__bar">
              <span class="hug-er-progress__bar__inner hug-er-progress__bar__inner--blue" [style.width.%]="getAcumenData2(passage)"></span>
            </div>
            <p class="hug-er-progress__percentage">{{getAcumenData2(passage)}}%</p>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal modal--efli" [ngClass]="{'active':ufliStrategyModal}" id="modalExample" *ngIf="ufliStrategyClickFlag">
    <div class="modal__box">
      <div class="modal__header hidden">
        <h2>UFLI strategies</h2>
        <button class="close" aria-label="Close" (click)="handleUfliSTratergyModal(false)">×</button>
      </div>
      <div class="modal__body">
        <div class="hug-efli-header">
          <p>
            <strong>UFLI:</strong>
            {{lessonDetails?.ufli_strategies}}
          </p>
        </div>
        <div class="hug-efli-body">
          <iframe class="w-100 h-100" [src]="sanitizedWordUrl" frameborder="0" allowfullscreen="true"
            webkitallowfullscreen="true" mozallowfullscreen="true"></iframe>
        </div>
      </div>
    </div>
  </div>

  <footer class="hug-tutor-footer pt-1">
    <div class="hug-container">
      <p class="hug-copyright">© Help Us Grow Reading Program</p>
    </div>
  </footer>
</div>